import React from 'react';
import { Alert, Button, Text } from '@nimbus-ds/components';
import { useGetInstallationStatusAlert } from 'commons/hooks';
import {
  EmptyStateMexicoStatus,
  MessageCode,
  MessageSeverity,
  NextActionCode,
} from 'commons/types';

interface InstallationStatusAlertProps {
  show: boolean;
  status: EmptyStateMexicoStatus;
  requestDate?: string;
  messageCode?: MessageCode;
  messageSeverity?: MessageSeverity;
  nextActionCode?: NextActionCode;
  deadline?: string;
  handleClick?: () => void;
  onRemove?: () => void;
}

function InstallationStatusAlert({
  status,
  show,
  requestDate,
  messageCode,
  messageSeverity,
  nextActionCode,
  deadline,
  handleClick,
  onRemove,
}: InstallationStatusAlertProps) {
  const {
    appearance,
    colorText,
    description,
    isBtnRequired,
    title,
    primaryBtn,
  } = useGetInstallationStatusAlert({
    status,
    requestDate,
    messageCode,
    messageSeverity,
    nextActionCode,
    deadline,
  });

  return (
    <Alert appearance={appearance} show={show} onRemove={onRemove}>
      <Text fontWeight="bold" color={colorText}>
        {title}
      </Text>
      <Text>{description}</Text>
      {isBtnRequired && (
        <Button appearance="primary" onClick={handleClick}>
          {primaryBtn}
        </Button>
      )}
    </Alert>
  );
}

export default InstallationStatusAlert;
